import './CustomCheckbox.css';

export default function CustomCheckbox({value, label, onChange, image, color}) {
  return <div className={'custom-checkbox-container' + (image !== undefined || color !== undefined  ? ' with-image-or-color' : '')} onClick={()=> {
    onChange(!value);
  }}><img className={'checkbox-image'} src={('/img/chekbox-'+(value ? 'true' : 'false')+'.svg')}/>
    {image !== undefined ? <img className={'image-for-item'} src={image}/> : ''}
    {color !== undefined ? <div className={'color-for-item'} style={{backgroundColor: color}}/> : ''}
    {label}</div>;
}